import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./footerLayout.css";

const NewsletterForm = () => {
  const [errors, setErrors] = useState({});
  const [submission, setSubmission] = useState({ status: "idle", message: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formElement = event.currentTarget;
    const form = new FormData(formElement);
    const values = Object.fromEntries(form.entries());
    const nextErrors = {};

    if (!values.name.trim()) nextErrors.name = "Name is required";
    if (!values.email.trim()) {
      nextErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      nextErrors.email = "Enter a valid email address";
    }
    if (!values.subject.trim()) nextErrors.subject = "Subject is required";

    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    setSubmission({ status: "sending", message: "Sending your enquiry..." });

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/info@studyconcerns.com",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            Name: values.name,
            Email: values.email,
            Subject: values.subject,
            "WhatsApp Number": values.whatsapp || "Not provided",
            "Desired Country": values.country || "Not provided",
            _replyto: values.email,
            _subject: `Website enquiry: ${values.subject}`,
            _template: "table",
            _captcha: "false",
          }),
        }
      );

      const result = await response.json();
      if (!response.ok || result.success === false || result.success === "false") {
        throw new Error(result.message || "Unable to send your enquiry.");
      }

      formElement.reset();
      setErrors({});
      setSubmission({
        status: "success",
        message: "Thank you! Your enquiry has been sent successfully.",
      });
    } catch (error) {
      setSubmission({
        status: "error",
        message: error.message || "Unable to send. Please try again shortly.",
      });
    }
  };

  const fieldClass = (name) =>
    `newsletter-form-control${errors[name] ? " error" : ""}`;

  return (
    <section className="newsletter-form-area">
      <Container>
        <Row>
          <Col md="12">
            <div className="newsletter-container">
              <div className="newsletter-box">
                <div className="sec-title text-center">
                  <h4>Get The Latest News &amp; Updates On Your Box</h4>
                </div>
                <form className="form" onSubmit={handleSubmit} noValidate>
                  <Row className="newsletter-fields">
                    <Col lg="4" md="6">
                      <p className={fieldClass("name")}>
                        <input name="name" type="text" placeholder="Enter Your Name" />
                        <span className="input-msg2">{errors.name}</span>
                      </p>
                    </Col>
                    <Col lg="4" md="6">
                      <p className={fieldClass("email")}>
                        <input name="email" type="email" placeholder="Enter Your Email" />
                        <span className="input-msg2">{errors.email}</span>
                      </p>
                    </Col>
                    <Col lg="4" md="6">
                      <p className={fieldClass("subject")}>
                        <input name="subject" type="text" placeholder="Enter Subject" />
                        <span className="input-msg2">{errors.subject}</span>
                      </p>
                    </Col>
                    <Col lg="4" md="6">
                      <p className="newsletter-form-control">
                        <input
                          name="whatsapp"
                          type="tel"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength="15"
                          onInput={(event) => {
                            event.currentTarget.value = event.currentTarget.value.replace(
                              /\D/g,
                              ""
                            );
                          }}
                          placeholder="Enter WhatsApp Number (Optional)"
                        />
                      </p>
                    </Col>
                    <Col lg="4" md="6">
                      <p className="newsletter-form-control">
                        <input
                          name="country"
                          type="text"
                          placeholder="Enter Desired Country (Optional)"
                        />
                      </p>
                    </Col>
                    <Col lg="4" md="6">
                      <button type="submit" disabled={submission.status === "sending"}>
                        <i className="las la-envelope"></i>
                        {submission.status === "sending" ? "Sending..." : "Subscribe Now"}
                      </button>
                    </Col>
                  </Row>
                  {/* {submission.message && (
                    <p
                      className={`newsletter-status newsletter-status-${submission.status}`}
                      role="status"
                    >
                      {submission.message}
                    </p>
                  )} */}
                </form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NewsletterForm;
